module.exports = __webpack_public_path__ + "static/media/menu_icon_mofftre_hover.e41882d4.png";